// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {orderBy} from 'lodash';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import RecordDetails from '../core/record-details';
import RecordLocker from '../app/record-locker';
import SearchPagination from '../app/search-pagination';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-failures.scss';

const servicesDataKey = 'failures';

class MediaItemFailures extends Component {
    getMediaItemGuid() {
        const {routerParams} = this.props;

        return routerParams.guid;
    }

    getPaginationProps() {
        return {
            maxResults: 50000,
            maxPages: 9,
        };
    }

    getRecordDetailsProps() {
        return {
            className: 'mediaitem-failures--record-details',
            whitelistKeys: ['category', 'rule', 'reason', 'lastUpdated', 'idFromPartner', 'provider', 'network'],
        };
    }

    renderFailures() {
        const {searchData: searchDataProp} = this.props;
        const searchData = orderBy(searchDataProp, ['lastUpdated'], ['desc']);
        const content = searchData.map((dataRow, key) => (
            <div className="mediaitem-failures--record" key={key}>
                <RecordDetails {...this.getRecordDetailsProps()} searchData={[dataRow]} />
            </div>
        ));
        return content;
    }

    renderRecordLocker() {
        const recordId = this.getMediaItemGuid();

        return recordId ? (
            <Permissions accessRequirement="write" requiresServiceAccess={true}>
                <RecordLocker recordId={recordId} serviceKey="mediaItems" />
            </Permissions>
        ) : null;
    }

    render() {
        const {error, fetching} = this.props;
        const failures = !fetching ? this.renderFailures() : [];

        return this.getMediaItemGuid() ? (
            <div className="mediaitem-failures">
                {this.renderRecordLocker()}
                <div className="mediaitem-failures--content">
                    <Error error={error} />
                    <div className="mediaitem-failures--title">Rule Validation Failures</div>
                    <SearchPagination {...this.getPaginationProps()} />
                    {failures.length > 0 || fetching ? (
                        failures
                    ) : (
                        <div className="mediaitem-failures--no-items">No failures to display</div>
                    )}
                    <Loading loading={fetching} />
                </div>
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

MediaItemFailures.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(MediaItemFailures, servicesDataKey);
